import React, { useState } from "react";
import { LocateFixed, Loader2 } from "lucide-react";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

/** GPS → street address → onResolve(address). On denial/failure the field is left untouched. */
export default function UseLocationButton({ onResolve, compact = false, testId = "use-current-location" }) {
  const [busy, setBusy] = useState(false);

  const locate = () => {
    if (!navigator.geolocation) { toast.error("Location isn't available on this device"); return; }
    setBusy(true);
    navigator.geolocation.getCurrentPosition(
      async ({ coords }) => {
        try {
          const r = await fetch(`${BACKEND}/api/reverse-geocode?lat=${coords.latitude}&lng=${coords.longitude}`);
          if (!r.ok) throw new Error("no address");
          const d = await r.json();
          onResolve(d.address);
          toast.success("Pickup set to your current location");
        } catch {
          toast.error("Couldn't turn your location into an address — please type it");
        } finally { setBusy(false); }
      },
      (err) => {
        setBusy(false);
        toast.error(err.code === 1 ? "Location permission denied — type the pickup address instead" : "Couldn't get your location — type the pickup address instead");
      },
      { enableHighAccuracy: true, timeout: 12000, maximumAge: 60000 },
    );
  };

  return (
    <button type="button" data-testid={testId} onClick={locate} disabled={busy}
      title="Use my current location as the pickup address"
      className={`inline-flex items-center gap-1.5 border border-[#A1A1AA]/30 text-[#A1A1AA] hover:text-[#D4AF37] hover:border-[#D4AF37] transition-colors disabled:opacity-50 ${compact ? "px-2 py-2" : "px-3 py-2 text-[10px] uppercase tracking-[0.18em]"}`}>
      {busy ? <Loader2 size={14} className="animate-spin"/> : <LocateFixed size={14}/>}
      {!compact && <span className="hidden sm:inline">{busy ? "Locating…" : "Current location"}</span>}
    </button>
  );
}
